<template>
  <div class="sheet-selection-grid">
    <SheetSelectionCard
      v-for="itemGroupItem in itemGroupItems"
      :key="itemGroupItem.itemGroupItemId"
      :item-group-item="itemGroupItem"
      :cart-bundle-id="cartBundleId"
      class="sheet-selection-grid__card"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { usePackageBuilderStore } from '@/stores/packageBuilder'
import { mapState } from 'pinia'

import { orderBy } from 'lodash-es'

import SheetSelectionCard from '@/components/Senior/PackageBuilder/SheetSelectionCard.vue'

import type { ItemGroupItemStorefrontDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'

export default defineComponent({
  name: 'SheetSelectionGrid',
  components: { SheetSelectionCard },
  props: {
    // The cart bundle whose SheetSelection group this grid renders.
    cartBundleId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(usePackageBuilderStore, ['sheetSelectionGroupForCartBundle']),
    itemGroupItems(): ItemGroupItemStorefrontDto[] {
      return orderBy(
        this.sheetSelectionGroupForCartBundle(this.cartBundleId)?.itemGroupItems ?? [],
        'zOrder'
      )
    }
  }
})
</script>

<style scoped lang="scss">
// Two columns is the ceiling: the grid now sits inside the step's right-hand
// selection card (roughly half the page at `lg`), where the old 3- and 4-across
// tiers would squeeze the cards past legibility. Mobile is a single column, per
// the mobile comp.
.sheet-selection-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;

  @include media-breakpoint-up(sm) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem;
  }

  @include media-breakpoint-up(lg) {
    // Figma's 40px inter-card gap (node 9196:234093).
    gap: 2.5rem;
  }
}
</style>
